export const stateOptions: any = [
  { value: 'CA', label: 'California' },
  { value: 'other', label: 'Other' },
];
